/**
 * Familienkonto: Pflichtfelder / Vollständigkeit (Spiegel der Serverregel in
 * App\Services\FamilyAccountCompleteness; der Server bleibt maßgeblich, hier
 * nur Sofort-Rückmeldung im Formular und lesbare Feldnamen).
 */
import type { V1ProfileOption } from './v1';

/** Feldname (API) -> i18n-Schlüssel des Anzeigenamens. */
export const FAMILY_ACCOUNT_FIELD_LABEL_KEYS: Record<string, string> = {
  wohnsituation: 'pflege.form.field.wohnsituation',
  wohnort: 'pflege.form.field.wohnort',
  wohnzustand: 'pflege.familienkonto.detail.wohnen.wohnzustand',
  haustiere: 'pflege.form.field.haustiere',
  haustiere_welche: 'pflege.familienkonto.detail.wohnen.haustiere_welche',
  einkaufsmoeglichkeiten: 'pflege.form.field.einkaufsmoeglichkeiten',
  raucherhaushalt: 'pflege.familienkonto.detail.wohnen.raucherhaushalt',
};

/** Bedeutet der gewählte Haustiere-Wert (Options-ID oder Klartext) „Ja"? */
export function isPetYes(
  value: string | null | undefined,
  options?: Record<string, V1ProfileOption[]> | null,
): boolean {
  const v = String(value ?? '').trim();
  if (!v) return false;
  if (v.toLowerCase() === 'ja') return true;
  const hit = options?.haustiere?.find(o => String(o.id) === v);
  return !!hit && String(hit.value).trim().toLowerCase() === 'ja';
}
